<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import utilsService from '@/services/core/utils.service';
    import httpService from '@/services/core/http.service';
    import ButtonSpinner from '@/components/shared/ButtonSpinner';
    import CollectionsHoldAlert from '@/components/shared/CollectionsHoldAlert';
    import store from '@/store/global.store';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            ButtonSpinner,
            CollectionsHoldAlert
        },
        data() {
            return {
                isLoading: 0,
                item: {}
            };
        },
        computed: {
            isReadOnly() {
                return store.getters.currentUser()?.isReadOnly === true;
            },
            canBeBookie() {
                return this.item.role === 'Exec' || this.item.bookie === true;
            }
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            save() {
                if (this.isReadOnly) return;

                const { id, password, email, phoneNumber, bookie } = this.item;
                const url = `users/${id}`;

                this.isLoading++;
                httpService
                    .put(url, { password, email, phoneNumber, bookie })
                    .then(() => {
                        utilsService.showToast('User was saved');
                        this.modalData.onSuccess && this.modalData.onSuccess();
                        this.close();
                    })
                    .finally(() => this.isLoading--);
            }
        },
        mounted() {
            this.item = utilsService.toJS(this.modalData.item || {});
        }
    };
</script>

<template>
    <Modal>
        <form class="gsb-form" @submit.prevent="save">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Edit User</h3>
                </div>
                <div class="modal-body" :class="{ 'gsb-readonly': isReadOnly }">
                    <CollectionsHoldAlert :hold="item.collectionsHold" :role="item.role" />
                    <fieldset>
                        <div class="row mb-3">
                            <label class="col-sm-3 col-form-label">Password</label>
                            <div class="col-sm">
                                <input v-model="item.password" type="text" class="form-control" />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm">
                                <input v-model="item.email" type="text" class="form-control" />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <label class="col-sm-3 col-form-label">Phone</label>
                            <div class="col-sm">
                                <input v-model="item.phoneNumber" type="text" class="form-control" />
                            </div>
                        </div>

                        <div v-if="canBeBookie" class="row">
                            <label id="isBookie" class="col-sm-3 col-form-label">Is Bookie?</label>
                            <div class="col-sm">
                                <input
                                    id="isBookie"
                                    type="checkbox"
                                    class="form-check-input"
                                    style="width: 20px; height: 20px"
                                    v-model="item.bookie"
                                />
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn" @click="close">Close</button>
                    <ButtonSpinner v-if="!isReadOnly" :isLoading="isLoading" />
                </div>
            </div>
        </form>
    </Modal>
</template>
